import { shouldUseNativeShare, shareFile, getMimeType } from "./mobileDownload";

/** Extract file extension from a URL or filename, stripping query params */
const getFormatFromPath = path => {
  try {
    const pathname = new URL(path, window.location.origin).pathname;
    const ext = pathname.split(".").pop();
    if (ext && ext.length <= 5) return ext;
  } catch {
    // Not a valid URL, try raw string
  }
  const ext = path.split(".").pop();
  if (ext && ext.length <= 5) return ext;
  return "png";
};

/** Download via blob URL — works on mobile because blob: is same-origin */
const downloadViaBlob = async (url, fileName) => {
  const response = await fetch(url);
  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke after a delay to ensure download starts
  setTimeout(() => URL.revokeObjectURL(blobUrl), 10000);
};

const downloadDesign = async ({ path, isTargetBlank, downloadName }) => {
  if (!path || ["MY_IMAGES", "MY_ANIMATIONS"].includes(path)) return;

  const isMobile = window.innerWidth <= 640;
  const format = downloadName
    ? getFormatFromPath(downloadName)
    : getFormatFromPath(path);
  const fileName = downloadName || `design.${format}`;

  // Try native share on mobile (saves to Camera Roll / Files)
  if (isMobile && shouldUseNativeShare(format)) {
    const mimeType = getMimeType(format);
    const shared = await shareFile(path, fileName, mimeType);
    if (shared) return;
  }

  // Mobile: fetch as blob then download via same-origin blob URL
  // (cross-origin <a download> is ignored by mobile browsers)
  if (isMobile) {
    try {
      await downloadViaBlob(path, fileName);
      return;
    } catch {
      // CORS or network error — fall through to anchor approach
    }
  }

  // Desktop (or mobile fallback) — standard anchor download
  const element = document.createElement("a");

  element.setAttribute("href", path);
  element.setAttribute("download", fileName);

  if (isTargetBlank) {
    element.setAttribute("target", "_blank");
  }

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export default downloadDesign;
